import { render } from "./ComponenteInputPerfilEolica.vue?vue&type=template&id=70205cba"
import script from "./ComponenteInputPerfilEolica.vue?vue&type=script&lang=js"
export * from "./ComponenteInputPerfilEolica.vue?vue&type=script&lang=js"

import "./ComponenteInputPerfilEolica.vue?vue&type=style&index=0&id=70205cba&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__